import axios from "axios";
import { getLoginUrl } from "utils/functions";

const _axios = axios
// Add a request interceptor
_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if ([401, 419].includes(error.response.status)) {
      const loginUrl = getLoginUrl()
      if (window.location.pathname !== loginUrl) {
        console.log("Error 4xx Unauthenticated")
        window.location.replace(loginUrl);
      }
      // window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

_axios.defaults.baseURL = process.env.REACT_APP_API_BASEURL;

// Important: If axios is used with multiple domains, the "authToken" will be sent to all of them.
// See below for an example using Custom instance defaults instead.
const authToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_NAME);
if (authToken) {
  window.authToken = authToken
  _axios.defaults.headers.common["Authorization"] = "Bearer " + authToken;
}

_axios.defaults.headers.common['Accept'] = 'application/json';
_axios.defaults.headers.common['Content-Type'] = 'application/json';

export default _axios
